import api from '../../api/_analyse'


const state = () => ({
    analyses: [],
    analyse: {},
    categoriesAnalyses: [],
    analysesByTypeConsult: [],
    demandesTraites: [],
    registre: [],
    plasmodiums: [],
    resultat: {},
    stadesPlasmodiums: [],
    prescripteur: {},
    analysesMinimalData:[],

    liste_registre_analyse: [],

    bulletin_analyses: [],
    bulletin_analyse_historique: [],

    tsl_filter_date: {}
})

// getters
const getters = {
    analyse: (state) => {
        return state.analyse
    },

    analyses: (state) => {
        return state.analyses
    },
    categoriesAnalyses: (state) => {
        return state.categoriesAnalyses
    },
    demandesTraites: (state) => {
        return state.demandesTraites
    },
    registre: (state) => {
        return state.registre
    },
    plasmodiums: (state) => {
        return state.plasmodiums
    },
    stadesPlasmodiums: (state) => {
        return state.stadesPlasmodiums
    },

    resultat: (state) => {
        return state.resultat
    },

    prescripteur: (state) => {
        return state.prescripteur
    },

    analyseByTypes: (state) => {
        return state.analysesByTypeConsult
    },

    analysesMinimalData:(state)=>{
        return state.analysesMinimalData
    },

    liste_registre_analyse:(state)=>{
        return state.liste_registre_analyse
    },

    bulletin_analyses:(state)=>{
        return state.bulletin_analyses
    },

    bulletin_analyse_historique: (state) => {
        return state.bulletin_analyse_historique
    },

    tsl_filter_date: (state) => {
        return  state.tsl_filter_date
    }
}

// mutations
const mutations = {
    SET_ANALYSE(state, analyse) {
        state.analyse = analyse
    },

    SET_CATEGORIES_ANALYSES(state, categoriesAnalyses) {
        state.categoriesAnalyses = categoriesAnalyses
    },

    SET_ANALYSES(state, analyses) {
        state.analyses = analyses
    },

    SET_DEMANDES_TRAITES(state, demandesTraites) {
        state.demandesTraites = demandesTraites
    },

    SET_REGISTRE(state, registre) {
        state.registre = registre
    },

    SET_PLASMODIUMS(state, plasmodiums) {
        state.plasmodiums = plasmodiums
    },

    SET_STADES_PLASMODIUMS(state, stadesPlasmodiums) {
        state.stadesPlasmodiums = stadesPlasmodiums
    },
    
    SET_RESULTAT(state, resultat) {
        state.resultat = resultat
    },

    SET_PRESCRIPTEUR(state, prescripteur) {
        state.prescripteur = prescripteur
    },

    SET_ANALYSES_FOR_TYPE_CONSULTATION(state, analyse) {
        state.analysesByTypeConsult = analyse
    },

    SET_ANALYSES_MINIMAL_DATA(state,analyses){
        state.analysesMinimalData = analyses
    },

    SET_LISTE_REGISTRE_ANALYSE(state, analyse) {
        state.liste_registre_analyse = analyse
    },

    SET_BULLETIN_ANALYSES(state, analyse) {
        state.bulletin_analyses = analyse
    },

    SET_BULLETIN_ANALYSE_HISTORIQUE(state, analyse) {
        state.bulletin_analyse_historique = analyse
    },

    SET_TSL_FILTER_DATE(state, tsl_filter_date) {
        state.tsl_filter_date = tsl_filter_date
    },
}

// actions
const actions = {
    saveAnalyse({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveAnalyse(data).then(
                response => {
                    dispatch('getAnalyses')
                    commit('SET_ANALYSES', response)
                    resolve(response);

                }, error => {

                    reject(error);
                }
            )
        })

    },
    deleteAnalyse({ dispatch }, id) {
        return new Promise((resolve, reject) => {
            api.deleteAnalyse(id).then(
                response => {
                    dispatch('getAnalyses')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveCategorieAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveCategorieAnalyse(data).then(
                response => {
                    dispatch('getAllCategoriesAnalyses')
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getBulletinAnalyses({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getBulletinAnalyses(data).then(
                response => {
                    if (data.est_encours == true) {
                        commit('SET_BULLETIN_ANALYSES', response)
                    } else {
                        commit('SET_BULLETIN_ANALYSE_HISTORIQUE', response)
                    }
                    
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    saveBulletinAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveBulletinAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    editRenseignementClinique({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.editRenseignementClinique(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteBulletinAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteBulletinAnalyse(data).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAnalyses({ commit }) {
        return new Promise((resolve, reject) => {

            api.getAnalyses().then(
                response => {
                    commit('SET_ANALYSES', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getAnalyse({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getAnalyse(id).then(
                response => {
                    commit('SET_ANALYSE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })

    },
    editAnalyse({ dispatch }, { id, data }) {
        return new Promise((resolve, reject) => {
            api.editAnalyse(id, data).then(
                response => {
                    //commit('SET_ANALYSE', response)
                    dispatch('getAnalyses')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })

    },

    getCategoriesAnalyses({ commit }) {
        return new Promise((resolve, reject) => {

            api.getCategoriesAnalyses().then(
                response => {
                    commit('SET_CATEGORIES_ANALYSES', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },
    getAllCategoriesAnalyses({ commit }) {
        return new Promise((resolve, reject) => {

            api.getAllCategoriesAnalyses().then(
                response => {
                    commit('SET_CATEGORIES_ANALYSES', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    searchAnalyses({commit}, search_word){
        return new Promise((resolve, reject) => {
            api.searchAnalyse(search_word).then(
                response => {
                    commit('SET_CATEGORIES_ANALYSES', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )

        })

    },

    getDemandesTraites({ commit }) {
        return new Promise((resolve, reject) => {

            api.getDemandesTraites().then(
                response => {
                    commit('SET_DEMANDES_TRAITES', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })


    },
    getRegistre({ commit }, analyse) {
        return new Promise((resolve, reject) => {
            api.getDemandesParametresResult(analyse).then(
                response => {
                    commit('SET_REGISTRE', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },
    saveDemandesResult({ dispatch }, { data, analyse }) {
        return new Promise((resolve, reject) => {
            api.saveDemandesResult(data).then(
                response => {
                    dispatch("getRegistre", analyse)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },
    getPlasmodiums({ commit }) {

        return new Promise((resolve, reject) => {

            api.getPlasmodiums().then(
                response => {
                    commit('SET_PLASMODIUMS', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })

    },
    getStadesPlasmodiums({ commit }) {

        return new Promise((resolve, reject) => {

            api.getStadesPlasmodiums().then(
                response => {
                    commit('SET_STADES_PLASMODIUMS', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })

    },
    getDemandeResult({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getDemandeResultat(id).then(
                response => {
                    commit('SET_RESULTAT', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })

    },

    getPrescripteur({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getPrescripteur(id).then(
                response => {
                    commit('SET_PRESCRIPTEUR', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    updateTDR({ dispatch }, { id, data, consultId }) {
        return new Promise((resolve, reject) => {
            api.updateTDR(id, data).then(
                response => {
                    resolve(response)
                    dispatch('getDemandeAnalyses', consultId)
                }, error => {
                    reject(error)
                }
            )
        })

    },
    getAnalysesByTypeConsultation({ commit }, type) {
        return new Promise((resolve, reject) => {
            api.getAnalysesByTypeConsultation(type).then(
                response => {
                    commit('SET_ANALYSES_FOR_TYPE_CONSULTATION', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getAnalysesMinimalData({ commit }){
        return new Promise((resolve, reject) => {
            api.getMinimalAnalyses().then(
                response => {
                    commit('SET_ANALYSES_MINIMAL_DATA', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })

    },
    importResultat({commit},{id,data}){
        return new Promise((resolve,reject) =>{
            api.importResultatAnalyse(id,data).then(
                response => {
                    commit
                    resolve(response)
                },error =>{
                    reject(error)
                }
            )
        })
    },

    updateResultatCommentaires({commit},{id,data}){
        return new Promise((resolve,reject) =>{
            api.updateResultatCommentaires(id,data).then(
                response => {
                    commit
                    resolve(response)
                },error => {
                    reject(error)
                }
            )
        })

    },

    saveAnalyseResult({ commit }, data) {
        return new Promise((resolve,reject) =>{
            api.saveAnalyseResult(data).then(
                response => {
                    commit
                    resolve(response)
                },error => {
                    reject(error)
                }
            )
        })
    },

    getRegistreAnalyse({ commit }) {
        return new Promise((resolve, reject) => {
            api.getRegistreAnalyse().then(
                response => {
                    commit('SET_LISTE_REGISTRE_ANALYSE', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    shareResultatAnalyse({ commit }, demande_analyse_id) {
        return new Promise((resolve,reject) =>{
            api.shareResultatAnalyse(demande_analyse_id).then(
                response => {
                    commit
                    resolve(response)
                },error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}